import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { RemovableCard, Text } from '@dixa/lib-shared-habla';
import { useCallback, useEffect, useState } from 'react';
import { TagSelect } from 'components/tagSelect';
import { conversationsBulkModalActionLabel } from '../../../utils/conversationsBulkModalActionLabel';
/**
 * Represents the component for the conversations bulk modal add or remove tag
 * action.
 */
export const ConversationsBulkModalTagAction = ({ conversationIds, type, onChange, onRemove, }) => {
    const [names, setNames] = useState([]);
    useEffect(() => {
        onChange({
            type,
            isValid: names.length > 0,
            arg: {
                action: type,
                csids: conversationIds,
                names,
            },
        });
    }, [onChange, names, type, conversationIds]);
    /** Handles the change of selected tags. */
    const handleChange = useCallback((tags) => {
        setNames(tags.map(({ name }) => name));
    }, []);
    return (_jsxs(RemovableCard, Object.assign({ icon: "tag", title: conversationsBulkModalActionLabel[type], onRemove: () => onRemove(type) }, { children: [_jsx(Text.Paragraph, Object.assign({ subdued: true, withMarginBottom: true }, { children: type === 'add_tag'
                    ? 'Select the tags you wish to bulk add to the selected conversations.'
                    : 'Select the tags you wish to bulk remove from the selected conversations.' })), _jsx(TagSelect, { allowMultiple: true, allowTagCreation: type === 'add_tag', includeDeactivated: type === 'remove_tag', allowSelectDeactivated: type === 'remove_tag', onChange: handleChange, placeholder: type === 'add_tag'
                    ? 'Select one or more tags to add'
                    : 'Select one or more tags to remove' })] })));
};
